export default {
  getIndustry: (state) => state.industry,
};
